import { useEffect, useState } from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useGetAddressTypes } from "@/services/RegisterCompany";
import { useTranslation } from "react-i18next";
import { AddressType } from "@/types";

interface SelectAddressTypeProps extends SelectProps {
  filterOut?: string[];
}

function SelectAddressType({ filterOut, ref, ...restProps }: SelectAddressTypeProps) {
  const [filteredAddressTypes, setFilteredAddressTypes] = useState<AddressType[]>([]);
  const { data: addressTypes, isLoading } = useGetAddressTypes();
  const { t } = useTranslation();

  useEffect(() => {
    if (addressTypes && filterOut) {
      const filtered = addressTypes.filter((type) => !filterOut.includes(type));
      setFilteredAddressTypes(filtered);
    } else {
      setFilteredAddressTypes(addressTypes || []);
    }
  }, [addressTypes, filterOut]);

  const options = transformDataToSelectOption(
    filteredAddressTypes || [],
    "none",
    "none",
    t,
    "enumerables:addressTypes"
  );

  return (
    <Select
      ref={ref}
      data={options}
      loading={isLoading}
      comboboxProps={{ withinPortal: true, zIndex: 10001 }}
      {...restProps}
    />
  );
}

export default SelectAddressType;
